import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import get from 'lodash-es/get';
import '@wdpr/wc-travel-agent-session-background-refresh';

import toQuerystring from '@finder/shared/utils/object/toQuerystring';
import { SyndicatedOptions } from '@finder/shared/components/syndicated-layout/syndicated-options.interface';
import { brandHeaderDefaultOptions, cachedPath } from '@finder/shared/components/syndicated-layout/syndicated-options';
import { SYNDICATED_HEADER_ANIMATIONS } from '@finder/shared/components/syndicated-layout/syndicated-header/syndicated-header.animations';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { TravelAgentService } from '@finder/shared/services/travel-agent/travel-agent.service';

@Component({
    selector: 'finder-syndicated-header',
    templateUrl: './syndicated-header.component.html',
    styleUrls: ['./syndicated-header.component.scss'],
    animations: [...SYNDICATED_HEADER_ANIMATIONS]
})
export class SyndicatedHeaderComponent implements OnInit {
    @Input() url: string;
    @Input() version: number;
    @Input() locale: string;
    @Input() language: string;
    @Input() siteId: string;
    @Input() environment: string;
    @Input() source: string;

    syndicatedHeaderUrl: string;
    defaultOptions: SyndicatedOptions;
    useCached = false; // @TODO validate if the user is not loggedIn to use cache.
    stateName: string;
    // Travel Agent session values
    extendTradeSessionUrl: string;
    extendTradeSessionInterval: number;
    isTravelAgentPage = false;

    constructor(
        private winRef: WindowRef,
        private travelAgentService: TravelAgentService,
    ) {}

    ngOnInit() {
        this.travelAgentService.init();
        this.isTravelAgentPage = this.travelAgentService.isValidTradeFlow();
        if (this.isTravelAgentPage) {
            this.extendTradeSessionUrl = this.travelAgentService.extendTradeSessionUrl;
            this.extendTradeSessionInterval = this.travelAgentService.extendTradeSessionInterval;
        }
        this.defaultOptions = {...brandHeaderDefaultOptions[this.siteId]};
        this.defaultOptions.version = this.version || this.defaultOptions.version;
        this.defaultOptions.locale = this.locale || this.defaultOptions.locale;
        this.defaultOptions.language = this.language || this.defaultOptions.language;
        this.defaultOptions.siteOverride = this.siteId;
        this.syndicatedHeaderUrl = `${this.url}${this.useCached ? cachedPath : '/'}${toQuerystring(this.defaultOptions)}`;
        this.stateName = 'loaded';
        // @TODO Remove this hack that prevents language modal to switch page's locale.
        // @see https://myjira.disney.com/browse/GIT-9534
        this.setupSyndicatedToggles();
    }

    headerStateDone(event: AnimationEvent) {
        // We want to make sure that the animation is complete and the style has been set
        // by the animation module. Once that is done we can manually remove the style attr.
        setTimeout(() => {
            event['element'].removeAttribute('style');
        });
    }

    /**
     * Setup toggles needed for Syndicated Navbar.
     *
     * @TODO Remove this hack that prevents language modal to switch page's locale.
     * @see https://jira.nge.wdig.com/browse/PRO-353284 see linked ticket for needed devwork.
     */
    setupSyndicatedToggles() {
        const releaseToggles = [
            'disableLocaleCookie',
            'disableLanguageSelectionCookie'
        ];

        const setToggles = () => {
            if (get(winRef, 'PEP.Config.Toggles.Release', false)) {
                releaseToggles.forEach((toggle) => {
                    winRef.PEP.Config.Toggles.Release[toggle] = true;
                });
                toggleReady.next(true);
            }
        };

        const winRef = this.winRef.nativeWindow;
        const toggleReady: Subject<boolean> = new Subject();
        // Use interval instead of timeout to prevent Angular stability issues in the main thread.
        const toggleSetupInterval = setInterval(setToggles, 100);
        toggleReady
            .asObservable()
            .pipe(
                first()
            )
            .subscribe(() => {
                clearInterval(toggleSetupInterval);
            });
    }
}

